import { useEffect, useState } from 'react';
import { useSwiper } from 'swiper/react';

export const useCarouselControls = () => {
  const swiper = useSwiper();

  const [stopped, setStopped] = useState(false);

  const play = () => {
    swiper?.autoplay?.start();
  };

  const stop = () => {
    swiper?.autoplay?.stop();
  };

  const slideNext = () => {
    swiper?.slideNext();
    stop();
  };

  const slidePrev = () => {
    swiper?.slidePrev();
    stop();
  };

  const onAutoplayStart = () => {
    setStopped(false);
  };

  const onAutoplayStop = () => {
    setStopped(true);
  };

  useEffect(() => {
    swiper.on('autoplayStart', onAutoplayStart);
    swiper.on('autoplayStop', onAutoplayStop);

    return () => {
      swiper.off('autoplayStart', onAutoplayStart);
      swiper.off('autoplayStop', onAutoplayStop);
    };
  }, [swiper]);

  return {
    stopped,
    setStopped,
    play,
    stop,
    slideNext,
    slidePrev,
  };
};
